import { ShiftModel } from "src/app/models/shift";

export interface ShiftsState
{
    models: Record<string, ShiftModel>;
    pagination: { pagesCount: number, page: number, limit: number };
    shifts: string[];
}

export const SHIFTS_FEATURE_KEY = 'shifts';